var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavouriteFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86515 17.562C8.62073 17.6905 8.31842 17.5965 8.18992 17.3521C8.13875 17.2548 8.12109 17.1433 8.13968 17.0349L8.75422 13.4519L6.15099 10.9144C5.95325 10.7216 5.94921 10.4051 6.14196 10.2073C6.21871 10.1286 6.31928 10.0773 6.4281 10.0615L10.0257 9.53878L11.6345 6.27883C11.7568 6.0312 12.0566 5.92953 12.3042 6.05174C12.4028 6.10041 12.4826 6.18022 12.5313 6.27883L14.1402 9.53878L17.7377 10.0615C18.011 10.1012 18.2003 10.355 18.1606 10.6282C18.1448 10.7371 18.0936 10.8376 18.0148 10.9144L15.4116 13.4519L16.0262 17.0349C16.0728 17.3071 15.89 17.5656 15.6179 17.6123C15.5095 17.6308 15.398 17.6132 15.3007 17.562L12.0829 15.8703L8.86515 17.562Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteFilled);
export default __webpack_public_path__ + "static/media/favouriteFilled.305af89e8a534ddc19df6d50eadd55c9.svg";
export { ForwardRef as ReactComponent };